import { RootState, SetState } from '@/store/useStore.ts';
import { LockUISlice } from './types';

export const lockUISlice = ({ set }: SetState<RootState>): LockUISlice => ({
  lockUI: false,
  setLockUI: (lockUI: boolean) =>
    set(
      (state: RootState) => ({ ...state, lockUI }),
      false,
      'lockUI/setLockUI',
    ),
});
